import Input from "../../Input"

const JailChannel = ({ index, values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">چنل زندان {index + 1}</h6>
            <div className="font-sans">
                <Input
                    type="number"
                    label="ایدی چنل *"
                    name={`jailChannels-${index}-id`}
                    placeholder="ChannelID"
                    options={serverData?.channelList}
                    autoComplete="off"
                    defaultValue={values?.id}
                    dir="ltr"
                />
            </div>
            <div className="grid grid-cols-2 gap-5">
                <div className="mt-2">
                    <Input
                        type="number"
                        name={`jailChannels-${index}-sgId`}
                        label="ایدی رنک زندان *"
                        options={serverData?.sgList}
                        placeholder="sgId"
                        autoComplete="off"
                        defaultValue={values?.sgId}
                        dir="ltr"
                    />
                </div>
                <div className="mt-2">
                    <Input
                        type="number"
                        name={`jailChannels-${index}-time`}
                        label="مدت زمان زندان به دقیقه *"
                        placeholder="time"
                        autoComplete="off"
                        defaultValue={values?.time}
                        dir="ltr"
                    />
                </div>
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="فرمت پوک"
                    name={`jailChannels-${index}-format`}
                    placeholder="format"
                    autoComplete="off"
                    defaultValue={values?.format}
                    dir="ltr"
                />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr">
                    <div>%time: تایم بن</div>
                </div>
            </div>
        </div>
    )
}

export default JailChannel
